import { render, staticRenderFns } from "./DistrictList.vue?vue&type=template&id=4bd0c53e&scoped=true"
import script from "./DistrictList.vue?vue&type=script&lang=js"
export * from "./DistrictList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0c53e",
  null
  
)

export default component.exports